import React from 'react';
import StatsCard from './StatsCard';

const ProjectValidation = () => {
  return (
    <StatsCard title="Validation des projets" loading={false} error={null}>
      <div style={{ textAlign: 'center', color: '#666', padding: '2rem' }}>
        <p>Contenu à venir...</p>
      </div>
    </StatsCard>
  );
};

export default ProjectValidation;
